// The hub on the new stack (next-dev): its own API, database and realm, next to the running system's.
export const environment = {
  /** Which apps' legal documents the hub edits (see models/legal-document.ts). */
  legalPlatforms: ['GENERAL', 'LAB', 'DENTIST', 'COURIER', 'ACCOUNTING_LINK'],
  production: false,
  api: {
    baseUrl: 'https://api-new.dev.dental-link.pumpkin.rs',
    // baseUrl: 'http://localhost:9090',
    endpoints: {
      partners: '/v1/admin/partners',
      tenants: '/v1/admin/tenants',
      users: '/v1/admin/users',
      cases: '/v1/admin/cases',
      shipments: '/v1/admin/shipments',
      attachments: '/v1/admin/attachments',
      usage: '/v1/admin/usage',
      catalogs: '/v1/admin/catalogs',
      legalDocuments: '/v1/admin/legal-documents',
      manufacturers: '/v1/admin/manufacturers'
    }
  },
  keycloak: {
    realm: 'pumpkin',
    authServerUrl: 'https://auth.dev.dental-link.pumpkin.rs',
    clientId: 'dl-hub'
  }
};
